import { FULL_DATE_SIX_FRACTIONAL_SECONDS } from '@lumapps/constants';
import { EVENTS } from '@lumapps/events/keys';
import { GLOBAL } from '@lumapps/translations';
import { getMoment } from '@lumapps/utils/time/getMoment';

const getTemporalityFilterValue = (temporality?: string) => {
    const moment = getMoment();
    const currentDate = moment().format(FULL_DATE_SIX_FRACTIONAL_SECONDS);

    if (temporality) {
        switch (temporality) {
            case GLOBAL.ALL_TIME:
                return {};
            case EVENTS.TEMPORALITY_PAST:
                return { endBefore: currentDate };
            case EVENTS.TEMPORALITY_ONGOING:
                return { endAfter: currentDate };
            case EVENTS.TEMPORALITY_FUTURE:
                return { startAfter: currentDate };
            default:
                return {};
        }
    }
    return {};
};

export { getTemporalityFilterValue };
